import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

const TRADES_ROUTING_PARAMS = {
  tradeId: 'tradeId',
  poolAction: 'poolAction',
  poolId: 'poolId',
};

export class CapitalMarketsPaths {
  static trades = new EnhancedPath('/capital-markets/trades');
  static tradeEdit = new EnhancedPath(
    `${CapitalMarketsPaths.trades.path}/:${TRADES_ROUTING_PARAMS.tradeId}/:${TRADES_ROUTING_PARAMS.poolAction}?/:${TRADES_ROUTING_PARAMS.poolId}?`,
  );
}

const routesConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: CapitalMarketsPaths.tradeEdit.path,
      component: lazyWithRetry(() => import('app/pages/capitalMarkets/trades/TradesListPage')),
      pageCode: PAGE_CODES.TRADE_MANAGEMENT,
    },
    {
      path: CapitalMarketsPaths.trades.path,
      component: lazyWithRetry(() => import('app/pages/capitalMarkets/trades/TradesListPage')),
      pageCode: PAGE_CODES.TRADE_MANAGEMENT,
    },
  ],
};

export default routesConfig;
